import {
  SET_SITE_LOADING,
  SET_CATEGORIES,
  SET_CURRENT_CATEGORY,
  SET_MENU_STATUS,
  ADD_TO_BUCKET,
  REMOVE_FROM_BUCKET,
  SET_CATEGORY_PRODUCTS,
  SET_CURRENT_PAGE,
  SET_POPUP,
  SET_USER,
  SHOW_MESSAGE,
  SET_CATEGORY_MENU_STATUS,
  SET_OPTIONS
} from "./types";

//import "isomorphic-fetch";
import store from "../store";

const API_URL = "https://eestipagar.ee/ep_catalog/wp-json/wp/v2/";
//const API_URL = "http://ep_catalog.localhost/index.php/wp-json/wp/v2/";
const VALIDATION_URL = "https://eestipagar.ee/ep_catalog/wp-json";

 /* const siteUrl = "https://eestipagar.ee/ep_catalog/wp-json";
   //const siteUrl = "http://ep_catalog.localhost/index.php/wp-json"; */

export const setPopup = (type, show) => (dispatch) => {
  const genObj = { type: type, show: show };
  dispatch({ type: SET_POPUP, popup: genObj });
};

export const setUser = (user) => (dispatch) => {
  dispatch({ type: SET_USER, user });
};

export const showMessage = (show, text = "") => (dispatch) => {
  dispatch({ type: SHOW_MESSAGE, show, text });
};

export const getCatalogOptions = () => (dispatch) => {
  fetch(`${VALIDATION_URL}/acf/v3/options/catalog_options`, {
    method: "GET",
  })
    .then((response) => response.json())
    .then((response) => {
      //console.log("Success:", response);
      dispatch({ type: SET_OPTIONS, response });
    })
    .catch((error) => console.error("Error:", error));
};

export const validateUser = (user) => (dispatch) => {
  //const { site } = this.props;
 // console.log("Validate user...");
  const token = (user && user.token) || localStorage.getItem("token");

  fetch(`${VALIDATION_URL}/jwt-auth/v1/token/validate`, {
    mode: "cors",
    headers: { Authorization: "Bearer " + token },
    method: "POST",
  })
    .then((response) => response.json())
    .then((response) => {
      //console.log("response:", response);
      if (response.data.status === 200) {
      } else {
        //console.log("SET USER FLASE");
        dispatch({ type: SET_USER, user: { loggedIn: false } });
      }
    })
    .catch((error) => console.error("Error:", error));
};

export const getProductCategories = () => (dispatch) => {
  fetch(`${API_URL}product_categories?per_page=100`, {
    method: "GET",
  })
    .then((response) => response.json())
    .then((response) => {
      //console.log("Success:", response);
      dispatch({ type: SET_CATEGORIES, response });
    })
    .catch((error) => console.error("Error:", error));
};

export const getCategoryProducts = (id) => (dispatch) => {
  fetch(
    `${API_URL}products?product_categories=${id}&per_page=100&orderby=menu_order&order=asc`,
    {
      method: "GET",
    }
  )
    .then((response) => response.json())
    .then((response) => {
      // console.log("Success:", response);
      let out = response;

      dispatch({ type: SET_CATEGORY_PRODUCTS, products: out, id });
    })
    .catch((error) => console.error("Error:", error));
};

export const setSiteLoading = (state = false, text = "") => (dispatch) => {
  let loadingArray = { state: state, text: text };
  dispatch({ type: SET_SITE_LOADING, loadingArray });
};

export const setCurrentPage = (page) => (dispatch) => {
  dispatch({ type: SET_CURRENT_PAGE, page });
};
export const setCurrentCategory = (category) => (dispatch) => {
  dispatch({ type: SET_CURRENT_CATEGORY, category });
};


export const setCategoryMenuState = (state) => (dispatch) => {
  dispatch({ type: SET_CATEGORY_MENU_STATUS, state });
};

export const setMenuState = (state) => (dispatch) => {
  dispatch({ type: SET_MENU_STATUS, state });
};

export const addToBucket = (product) => (dispatch) => {
  //console.log("ADD: ", product);
  dispatch({ type: ADD_TO_BUCKET, id: product.id, item: product });
};

export const removeFromBucket = (item) => (dispatch) => {
  //console.log("REMOVE: ", item);

  dispatch({ type: REMOVE_FROM_BUCKET, id: item, index: 2 });
};

export const outSideClick = (isMenuOpen) => (dispatch) => {
  if (isMenuOpen) {
    dispatch({ type: SET_MENU_STATUS, state: false });
  }
  //console.log("qowidjqowidjqoiwd");
};
